module.exports = __webpack_public_path__ + "static/ha8-5c3f2fbae3b4cf0df21b02d23480d2c8.jpg";